import { all, takeEvery, put, fork, call, delay, select } from 'redux-saga/effects';
import { initializeApp, deleteApp, getApps } from "firebase/app";
import { OAuthProvider, getAuth, signInAnonymously, signInWithCustomToken } from "firebase/auth";
import logError from '../../utils/logger';
import debug from '../../utils/debugLog';
import {
	AUTH_TOKEN,
	SIGNIN,
	SIGNINSECONDARY,
	SIGNOUT,
	SIGNUP,
	FORGET,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_OPENID,
	SIGNIN_WITH_FACEBOOK
} from '../constants/Auth';
import {
	showAuthMessage,
	authenticated,
	multiprojectPrompt,
	secondaryAuthenticated,
	signOutSuccess,
	signUpSuccess,
	signInWithGoogleAuthenticated,
	signInWithFacebookAuthenticated
} from "../actions/Auth";

import FirebaseService from 'services/FirebaseService'
import { auth } from 'auth/FirebaseAuth'
import { getNonDefaultApps, resolveSecondaryFirebaseConfig, MissingStagingConfigError } from 'utils/secondaryApp';

let hostname = window.location.hostname;
let subdominio = hostname.split('.')[0];
debug.log(subdominio)

const LTI_AUTO_LOGOUT_FLAG = 'lti_auto_logout';

// Diccionario para mapear subdominios a valores de provider
const providerMapping = {
	plataformaduoc: 'oidc.duoc-logistica',
	plataformaaiep: 'oidc.aiep-logistica', // Ejemplo de otro subdominio
	default: 'oidc.default' // Valor por defecto si no coincide ningún subdominio
  };
  
  // Obtener el valor del provider según el subdominio
  const providerValue = providerMapping[subdominio] || providerMapping.default;
  
  // Crear el provider con el valor correspondiente
  const provider = new OAuthProvider(providerValue);


let firebaseObject = [] // Arreglo de proyectos de usuario logueandose

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({payload}) {
		const {email, password, project} = payload;
		// Si no hay project, es step 0
		debug.log(project)
		if (!project) {
			try {
				const user = yield call(FirebaseService.signInEmailRequest, email, password)
				debug.log(user)
				if (user.message) {
					yield put(showAuthMessage(user.message, "error"))
				} else {
					let isMultiproyecto = false
					let projectsArray = []
					// window.localStorage.setItem('loginStep', '1')
					//Acá está logueado a la DB primaria. Capturar datos de DB secundaria.
					const snap = yield call(FirebaseService.getPrimaryUserData, user.user.uid)				
					debug.log('user', user)
					localStorage.setItem(AUTH_TOKEN, user.user.uid)
					localStorage.setItem("auth_email", email)
					const primary = snap.val()
					debug.log(snap)
					debug.log(primary)
					// Si primary es null, el usuario fue borrado de la DB primaria
					if(primary === null){
						debug.log("primary nulo", primary)
						// No continuar el login
						// Avisar que el usuario no existe
						// Permanecer en el login
						yield put(showAuthMessage("Email no registrado. Por favor, intente de nuevo.", "error"));
						// AUTH_TOKEN ya quedó escrito arriba y el reducer lo lee como sesión
						// válida al montar. Sin SIGNOUT el usuario entraría al shell sin
						// PRIMARY_DATA en la próxima carga.
						yield put({ type: SIGNOUT });
						return true
					}
					// Sobreescribe nombres de roles
					if("Rol" in primary){
						if(primary.Rol === "Profesor") primary.showRol = "Administrador"
						if(primary.Rol === "Alumno") primary.showRol = "Usuario"
					}
					primary.uid= user.user.uid
					localStorage.setItem("PRIMARY_DATA", JSON.stringify(primary))
					debug.log('PRIMARY DATA', primary)
					// Datos de DB primaria obtenidos. Ver si es arreglo o sólo tiene 1 proyecto.

					let firebaseData = {}
					if (Array.isArray(primary)) {
						// Es arreglo de Objetos
						// Se deben agrupar los datos Firebase de todas las instacias
						firebaseData = []
						primary.map(projectItem => {
						  firebaseData.push(projectItem.Firebase)
						  return true
						})
				
						firebaseObject = firebaseData
						isMultiproyecto = true
						// Recorre cada proyecto dentro del arreglo para extraer su uid
						firebaseData.map(projectItem => {
						  if (projectItem.projectId) {
							projectsArray.push(projectItem.projectId)
							return true
						  }
						  return true
						})
					  } else {
						firebaseData = primary.Firebase
						debug.log('firebase data es objeto or unexpected', firebaseData)
						isMultiproyecto = false
					  }

					  // Ya se ha determinado si el usuario tiene uno o más proyectos.
					  // Si solo tiene un proyecto
					if (!isMultiproyecto) {
						// loginStep = 0
						window.localStorage.setItem('loginStep', '0')
						window.localStorage.setItem('projectRef', '')
						debug.log('1 proyecto')
						debug.log('primary rol', primary.Rol)
						debug.log('primary nombre', primary.Nombre)
						localStorage.setItem("user_role", primary.Rol)
						localStorage.setItem("user_name", primary.Nombre)
						localStorage.setItem(AUTH_TOKEN, user.user.uid)
						localStorage.setItem("auth_email", email)
						// Log into secondary DB
						primary.uid= user.user.uid
						debug.log(primary)
						yield put({ type: SIGNINSECONDARY, payload: primary });
						// yield put(authenticated(user.user.uid));
					} 
					// Si es multiproyecto
					else {
						debug.log('Multiproyecto')
						window.localStorage.setItem('projectRef', '')
						yield put(multiprojectPrompt({							
							projectsList: projectsArray,
							projectsFirebase: firebaseData
						}));						
					}
				}
			} catch (err) {
				yield put(showAuthMessage(err, "error"));
			}
		}
		// Hay project, es step 1 de multiproyecto
		else{
			let firebaseConnection = ''
			let projectIndex = 0
			let finalProjectIndex = 0
			// Recorre el arreglo de proyectos obtenido en step 0
			firebaseObject.map(firebaseItem => {
			if (firebaseItem.projectId === project) {
				firebaseConnection = firebaseItem
				window.localStorage.setItem('projectRef', `${projectIndex.toString()}/`)
				finalProjectIndex = projectIndex
				return true
			}
			projectIndex += 1
			return true
			})
			// loginStep = 0
			window.localStorage.setItem('loginStep', '0')

			// Log into secondary DB
			const uid = localStorage.getItem("auth_token")			
			const allProjecstData = JSON.parse(localStorage.getItem("PRIMARY_DATA"))
			debug.log("allProjecstData",allProjecstData)
			let finalPayload = allProjecstData[finalProjectIndex]
			finalPayload.uid = uid
			localStorage.setItem("PRIMARY_DATA", JSON.stringify(finalPayload))
			debug.log('PRIMARY DATA', finalPayload)
			// signInSecondary(allProjecstData[finalProjectIndex]);
			yield put({ type: SIGNINSECONDARY, payload: finalPayload });
			// const userUid = localStorage.getItem("auth_token")
			// yield put(authenticated(userUid));
			yield put(showAuthMessage("Has ingresado con éxito al Administrador de Soluciones VR/AR.", "success"));
		}
	});
}

// Reintentos de lectura de Clients/{uid} en el login por OIDC. La Cloud Function
// onNewUserCreated escribe ese nodo de forma asíncrona al crearse la cuenta y en
// arranque frío puede tardar varios segundos: 10 x 3s da ~30s de margen.
const PRIMARY_MAX_INTENTOS = 10;
const PRIMARY_ESPERA_MS = 3000;

export function* signInWithOpenID() {
	yield takeEvery(SIGNIN_WITH_OPENID, function* () {
	  try {
		const user = yield call(FirebaseService.signInOpenIdRequest, provider);
		if (user.message) {
		  if (user.code === 'auth/popup-closed-by-user') {
			yield put(showAuthMessage('El popup fue cerrado antes de completar el inicio de sesión.', "error"));
		  } else {
			yield put(showAuthMessage(user.message, "error"));
		  }
		} else {
			// Login exitoso
			// logError("login exitoso");
			// logError(user);
			//Acá está logueado a la DB primaria. Capturar datos de DB secundaria.
			// El nodo Clients/{uid} lo escribe la Cloud Function onNewUserCreated (trigger
			// auth.user().onCreate) desde /UsuariosBase/{provider} cuando se crea la cuenta,
			// de forma asíncrona. En el primer login de un usuario nuevo todavía puede no
			// existir, así que se reintenta hasta que aparezca. El tope evita quedar girando
			// para siempre cuando el usuario no va a ser aprovisionado nunca, por ejemplo si
			// no hay plantilla para su provider y la function se rinde.
			let primary = null
			for (let intento = 1; intento <= PRIMARY_MAX_INTENTOS && primary === null; intento++) {
				const snap = yield call(FirebaseService.getPrimaryUserData, user.user.uid)
				localStorage.setItem(AUTH_TOKEN, user.user.uid)
				localStorage.setItem("auth_email", user.user.email)
				primary = snap.val()
				debug.log(primary)
				if(primary === null){
					debug.log(`primary nulo, intento ${intento}/${PRIMARY_MAX_INTENTOS}`)
					if (intento < PRIMARY_MAX_INTENTOS) yield delay(PRIMARY_ESPERA_MS);
				}
			}
			if(primary === null){
				// La cuenta quedó creada en Auth pero sin perfil en la primaria. Se cierra
				// sesión para que el próximo intento parta limpio, en vez de dejar al usuario
				// a medio loguear con AUTH_TOKEN ya escrito.
				// Sin email: logError escribe en la RTDB primaria y su contrato es no
				// guardar datos de usuario. El uid alcanza para ubicar el caso en Auth.
				logError(new Error(`OIDC: Clients/${user.user.uid} no existe tras ${PRIMARY_MAX_INTENTOS} intentos`))
				yield put(showAuthMessage("Tu cuenta se está preparando. Espera unos segundos y vuelve a iniciar sesión. Si el problema persiste, contacta a tu administrador.", "warning"));
				yield put({ type: SIGNOUT });
				return;
			}
			// Saliendo del ciclo, los datos de la DB primaria están listos
			primary.uid= user.user.uid
			localStorage.setItem("PRIMARY_DATA", JSON.stringify(primary))
			localStorage.setItem("user_role", primary.Rol)
			localStorage.setItem("user_name", primary.Nombre)
			// Log into secondary DB
			// signInSecondary(primary);			
			debug.log(primary)
			yield put({ type: SIGNINSECONDARY, payload: primary });
					
			// yield put(authenticated(user.user.uid));
			yield put(showAuthMessage("Has ingresado con éxito al Administrador de Soluciones VR/AR.", "success"));
		}
	  } catch (error) {
		debug.log(error);
		yield put(showAuthMessage(error.message, "error"));
	  }
	});
  }

  export function* signInSecondary() {
	yield takeEvery(SIGNINSECONDARY, function* ({ payload }) {
	  const primary = payload;
	  debug.log(primary)
	  try {
		// Verificar si el proyecto está deshabilitado
		const projectId = primary.Firebase && primary.Firebase.projectId;
		debug.log('[DisabledCheck] projectId:', projectId);
		if (projectId) {
		  const disabledInfo = yield call(FirebaseService.getDisabledProjectInfo, projectId);
		  debug.log('[DisabledCheck] disabledInfo:', disabledInfo);
		  if (disabledInfo) {
			localStorage.setItem('DISABLED_PROJECT_INFO', JSON.stringify(disabledInfo));
			yield put({ type: SIGNOUT });
			window.location.href = '/auth/disabled-project';
			return;
		  }
		}

		// Resolver config según entorno (staging usa Firebase.stagingURL)
		let resolvedFirebaseConfig;
		try {
		  resolvedFirebaseConfig = resolveSecondaryFirebaseConfig(primary);
		} catch (err) {
		  if (err instanceof MissingStagingConfigError) {
			debug.warn('[signInSecondary]', err.message);
			localStorage.setItem('MISSING_STAGING_CONFIG_INFO', JSON.stringify({
			  proyecto: primary?.Proyecto || '',
			  uid: primary?.uid || ''
			}));
			yield put({ type: SIGNOUT });
			window.location.href = '/auth/missing-staging-config';
			return;
		  }
		  throw err;
		}

		// Create secondary Firebase instance
		const rand = Math.random() * 100000;
		const secondaryApp = initializeApp(resolvedFirebaseConfig, primary.Proyecto + rand);
		localStorage.setItem("SECONDARY_DATA_NAME", primary.Proyecto + rand);
  
		const auth = getAuth(secondaryApp);
		yield call(signInAnonymously, auth);

		// Verificar admisión por lista de emails HECHO PARA DUOC
		if(primary.Proyecto === "DUOC Logística" || primary.Proyecto === "Laboratorio Electricidad"){
			const email = localStorage.getItem("auth_email");
			const isAdmitted = yield call(FirebaseService.checkEmailInSecondaryDB, primary.uid, email, secondaryApp, primary);
			debug.log(isAdmitted)
			if (!isAdmitted) {
			  yield put(showAuthMessage("No tienes acceso a esta aplicación. Por favor, contacta a tu administrador.", "warning"));
			  debug.log("No tiene acceso a la aplicación") 
			  yield put({ type: SIGNOUT });
			  return false;
			}
		}
  
		const uid = localStorage.getItem("auth_token");

		// Asegura el nodo del usuario en la secundaria y repone sus secuencias desde
		// Settings/SecuenciasIniciales. Corre en todos los proyectos: crea el usuario si
		// no existe y, si ya existe, solo agrega las secuencias faltantes (no pisa avances
		// ni los campos que escribe el flujo LTI).
		const { creado, secuenciasAgregadas } = yield call(
			FirebaseService.ensureUsuarioSecundario,
			secondaryApp,
			uid,
			primary,
			localStorage.getItem("auth_email")
		);
		if (creado) debug.log(`Usuario creado en secundaria: ${uid}`);
		if (secuenciasAgregadas > 0) debug.log(`Secuencias iniciales repuestas: ${secuenciasAgregadas}`);

		// Obtener submenús desde /Usuarios para aplicar submenús (si corresponde)
		const secondaryData = yield call(FirebaseService.getSecondaryUserData, secondaryApp, uid);
		localStorage.setItem("SECONDARY_SUBMENU", JSON.stringify(secondaryData.val()));
				
		yield put(secondaryAuthenticated(secondaryApp));
        
		// Condición de loading removida para trabajar con SSO, pero causa doble rendereo en las demás vistas
        yield put(authenticated(uid));
           
  
	  } catch (err) {
		debug.log(err)
		logError(err)
		yield put(showAuthMessage(err, "error"));
	  }
	});
  }

  export function* forget() {
	yield takeEvery(FORGET, function* ({payload}) {
		const {email} = payload;
		  try {
			  const forget = yield call(FirebaseService.forgetPassword, email);
			  if (forget === undefined) {
				// Email correcto				
				yield put(showAuthMessage("Hemos enviado a su email las instrucciones para continuar.", "success"));
			} else {
				// Email no válido
				yield put(showAuthMessage("Email no registrado. Por favor, intente de nuevo.", "error"));
			}
		  } catch (err) {
				debug.log(err)
			  yield put(showAuthMessage(err, "error"));
		  }
	  });
  }

export function* signOut() {
  yield takeEvery(SIGNOUT, function* () {
		try {
			const signOutUser = yield call(FirebaseService.signOutRequest);
			if (signOutUser === undefined) {
				localStorage.removeItem(AUTH_TOKEN);
				localStorage.removeItem("projectRef");
				localStorage.removeItem("usuario");
				localStorage.removeItem("PRIMARY_DATA");
				localStorage.removeItem("SECONDARY_SUBMENU");
				localStorage.removeItem("SECONDARY_DATA_NAME");
				localStorage.removeItem("auth_email");
				localStorage.removeItem("user_role");
				localStorage.removeItem("user_name");
				sessionStorage.removeItem(LTI_AUTO_LOGOUT_FLAG);
				sessionStorage.removeItem('lti_claims');
				yield put(signOutSuccess(signOutUser));
				const secondaryApps = getNonDefaultApps();
				for (const app of secondaryApps) {
					yield call(() => deleteApp(app));
				}
				
			} else {
				yield put(showAuthMessage(signOutUser.message, "success"));
			}
		} catch (err) {
			yield put(showAuthMessage(err, "error"));
		}
	});
}

// Sign in using a Firebase custom token (e.g. received from LTI launch)
export function* signInWithCustomTokenSaga() {
	yield takeEvery('SIGNIN_WITH_CUSTOM_TOKEN', function* ({ payload }) {
		try {
			const { token } = payload || {};
			if (!token) {
				yield put(showAuthMessage('Missing custom token', 'error'));
				return;
			}

			// Sign in using Firebase Auth with the provided custom token
			const result = yield call(signInWithCustomToken, auth, token);
			if (result && result.user) {
				const user = result.user;
				sessionStorage.setItem(LTI_AUTO_LOGOUT_FLAG, '1');
				localStorage.setItem(AUTH_TOKEN, user.uid);
				localStorage.setItem('auth_email', user.email || '');

				// Fetch primary user data and continue the existing flow
				const snap = yield call(FirebaseService.getPrimaryUserData, user.uid);
				const primary = snap.val();
				if (primary === null) {
					yield put(showAuthMessage('User not provisioned in primary DB', 'error'));
					// Mismo motivo que en el login por email: AUTH_TOKEN ya está escrito.
					yield put({ type: SIGNOUT });
					return true;
				}

				primary.uid = user.uid;
				localStorage.setItem('PRIMARY_DATA', JSON.stringify(primary));

				// Extraer claims LTI del token y guardarlos en sessionStorage.
				// Estos claims contienen el Curso actualizado directamente del launch LTI
				// y son la fuente de verdad (no dependen de lecturas a la BBDD).
				try {
					const idTokenResult = yield call([user, 'getIdTokenResult'], true);
					if (idTokenResult.claims && idTokenResult.claims.lti) {
						sessionStorage.setItem('lti_claims', JSON.stringify({
							curso: idTokenResult.claims.curso || '',
							seccion: idTokenResult.claims.seccion || '',
							sede: idTokenResult.claims.sede || '',
							programa: idTokenResult.claims.programa || '',
								labelValid: idTokenResult.claims.labelValid !== false
						}));
					}
				} catch (claimsErr) {
					debug.warn('No se pudieron extraer claims LTI del token', claimsErr);
				}

				// Proceed to sign into secondary DB or dispatch authenticated
				yield put({ type: SIGNINSECONDARY, payload: primary });
			}
		} catch (err) {
			console.error('Error in signInWithCustomTokenSaga', err);
			yield put(showAuthMessage(err.message || err, 'error'));
		}
	});
}

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({payload}) {
		const {email, password} = payload;
		try {
			const user = yield call(FirebaseService.signUpEmailRequest, email, password);
			if (user.message) {
				yield put(showAuthMessage(user.message, "error"));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signUpSuccess(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error, "error"));
		}
	}
	);
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
		try {
			const user = yield call(FirebaseService.signInGoogleRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message, "error"));
			} else {
				debug.log(user)
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signInWithGoogleAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error, "error"));
		}
	});
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
		try {
			const user = yield call(FirebaseService.signInFacebookRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message, "error"));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signInWithFacebookAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error, "error"));
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(signInWithFBEmail),
		fork(signInSecondary),	
		fork(forget),	
		fork(signOut),
		fork(signUpWithFBEmail),
		fork(signInWithFBGoogle),
		fork(signInWithFacebook),
		fork(signInWithOpenID),
		fork(signInWithCustomTokenSaga)
  ]);
}
